export const EditFormTitles = {
  FAQ: "FAQ",
  TalkToUs: "Talk To Us",
  TermsOfService: "Terms Of Service",
  Privacy: "Privacy",
  Logout: "Logout",
  DeleteAccount: "Delete Account",
};
